import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { UserManager } from 'oidc-client-ts';
import { CONFIG } from 'src/global-config';
import { appStorage } from 'src/lib/localStorage';

export const baseQuery = (baseUrl: string) => {
  const storageKey = `oidc.user:${window.RUNTIME_CONFIG.KEYCLOAK_AUTHORITY}/${window.RUNTIME_CONFIG.KEYCLOAK_REALM}:${window.RUNTIME_CONFIG.KEYCLOAK_CLIENT}`;
  return fetchBaseQuery({
    baseUrl,
    credentials: 'include',
    prepareHeaders: (headers) => {
      const clientId = getCurrentClientId();
      const token = JSON.parse(sessionStorage.getItem(storageKey) ?? '{}').access_token;

      headers.set('Authorization', `Bearer ${token}`);
      if (clientId) {
        headers.set('X-Client-Id', clientId);
      }

      return headers;
    },
  });
};

export const authQuery = async (args: any, api: any, extraOptions: any) => {
  const baseQueryWithDynamicUrl = baseQuery(
    extraOptions?.baseUrl || window.RUNTIME_CONFIG.PRESENTATION_SERVICE
  );

  const result = await baseQueryWithDynamicUrl(args, api, extraOptions);

  if (result.error && result.error.status === 401) {
    // 401 means the session token is invalid or expired — sign the user out.
    // 403 (permission denied) must NOT trigger a sign-out; the user is
    // authenticated but lacks a specific permission for that endpoint.
    await new UserManager(window.OIDC_CONFIG).signoutRedirect();
  }

  // Transform APIResponse<T> to just T for successful responses
  if (result.data && typeof result.data === 'object' && 'success' in result.data) {
    const apiResponse = result.data as APIResponse<any>;
    if (apiResponse.success === true && 'result' in apiResponse) {
      return { ...result, data: apiResponse.result };
    }
  }

  return result;
};

export const getCurrentClientId = () => {
  const storageKey = `oidc.user:${window.RUNTIME_CONFIG.KEYCLOAK_AUTHORITY}/${window.RUNTIME_CONFIG.KEYCLOAK_REALM}:${window.RUNTIME_CONFIG.KEYCLOAK_CLIENT}`;

  const clientId = JSON.parse(sessionStorage.getItem(storageKey) ?? '{}').profile?.clientId;
  const workspaceClientId = appStorage.getItem(CONFIG.WORKSPACE_LOCAL_STORAGE_KEY) as string;

  if (clientId) {
    return clientId;
  } else if (workspaceClientId) {
    // Don't merge to one IF. Fixes a case where a user is logged in after operator. Non operators always have clientId.
    return workspaceClientId;
  }

  return null;
};
